import { app } from '../../../../../../app';
import { Controller } from './copy-accounts-to-groups.controller';

app.component('companyUserDirectoriesDirectoryGroupsAllAccountsCopy', {
    bindings: {
        accounts: '<',
        companyId: '<',
        groups: '<',
    },
    controller: Controller,
    templateUrl: require('./copy-accounts-to-groups.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/all-accounts/copy/copy-accounts-to-groups.component.js